import { cn } from "@/lib/utils";

/**
 * Zaroor Global Trading — Brand Mark
 *
 * Concept: A stylized "Z" monogram in which two emphasized nodes mark the start
 * and end of the path. The mark visualises Zaroor's core function — connecting
 * a verified supplier (origin) with a buyer (destination) through a single
 * dependable channel of global trade.
 */
const LogoMark = ({ className }) => (
    <svg
        viewBox="0 0 32 32"
        fill="none"
        stroke="currentColor"
        className={className}
        aria-hidden="true"
    >
        {/* Subtle backdrop ring for depth */}
        <circle cx="16" cy="16" r="13" stroke="currentColor" strokeOpacity="0.18" strokeWidth="1" />
        {/* The "Z" — three connected strokes forming the trade-route monogram */}
        <path
            d="M9 9 L23 9 L11 23 L23 23"
            strokeWidth="2.75"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        {/* Origin node (top-left) — represents the supplier */}
        <circle cx="9" cy="9" r="1.9" fill="currentColor" />
        {/* Destination node (bottom-right) — represents the buyer */}
        <circle cx="23" cy="23" r="1.9" fill="currentColor" />
    </svg>
);

export const Logo = ({ className, variant = "dark" }) => {
    const isLight = variant === "light";
    return (
        <a
            href="#top"
            className={cn("flex items-center gap-2.5 group", className)}
            aria-label="Zaroor Global Trading LLC"
        >
            <span
                className={cn(
                    "relative grid place-items-center w-9 h-9 rounded-md transition-smooth",
                    isLight
                        ? "bg-white/10 ring-1 ring-white/15 text-white group-hover:bg-white/15"
                        : "bg-primary text-primary-foreground group-hover:bg-primary-variant"
                )}
            >
                <LogoMark className="w-[22px] h-[22px]" />
            </span>
            <div className="flex flex-col leading-tight">
                <span
                    className={cn(
                        "font-display text-[15px] font-semibold tracking-tight",
                        isLight ? "text-white" : "text-foreground"
                    )}
                >
                    Zaroor Global
                </span>
                <span
                    className={cn(
                        "text-[10px] uppercase tracking-[0.18em]",
                        isLight ? "text-white/60" : "text-muted-foreground"
                    )}
                >
                    Trading LLC
                </span>
            </div>
        </a>
    );
};

export default Logo;
